import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=e2337e92&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=js&"
export * from "./Paging.vue?vue&type=script&lang=js&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=e2337e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2337e92",
  null
  
)

export default component.exports